module.exports = __webpack_public_path__ + "VAGRoundedStd-Bold.3d6f0271eb1b924fa99c.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Bold.svg
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Bold.svg
// module chunks = styles